/** Amministrazione: accessi e ruoli, liste e criteri, registro operazioni, casi Salesforce in prova. */
import type { Forma } from "../forma";

export const it = {
  accessi: {
    titolo: "Accessi e ruoli",
    sottotitolo: "Schema standard dei portali: app Entra, ruoli per sezione, gruppo sso-qa.",
    invita: "Aggiungi una persona",
    invitaNota: "Prepara l'utente con i suoi ruoli, uno per sezione: entra con l'account Brandart. Nessuna mail automatica.",
    email: "Email",
    nome: "Nome",
    ruolo: "Ruolo",
    aggiunto: "Utente preparato",
    ruoli: "Ruoli",
    sezione: "Sezione",
    anche: "anche",
    almenoUnRuolo: "Almeno un ruolo",
    chi: "Chi",
    cosaFa: "Cosa può fare",
    nessunoTest: "nessuno nel test",
    soloMario: "Nel test entra solo Mario. Le altre persone si aggiungono dopo la revisione, senza mail automatiche.",
    ssoSpento: "SSO non attivo su questo ambiente: vale il login di sviluppo.",
    utenti: "Utenti",
    stato: "Stato",
    attivo: "attivo",
    disattivato: "disattivato",
    disattiva: "Disattiva",
    riattiva: "Riattiva",
    ultimoAccesso: "Ultimo accesso",
    richieste: "Richieste di accesso",
    nessunaRichiesta: "Nessuna richiesta",
    nessunaRichiestaNota: "Chi entra senza ruolo vede «Chiedi l'accesso»; la richiesta arriva qui.",
    motivo: "Motivo",
    quando: "Quando",
    gestita: "Gestita",
    rifiuta: "Rifiuta",
    statoRichiesta: { aperta: "aperta", gestita: "gestita", rifiutata: "rifiutata" },
    salvato: "Salvato",
  },
  liste: {
    titolo: "Liste e criteri",
    sottotitolo: "Le regole che oggi stanno nella testa delle persone, scritte una volta.",
    severita: "Severità",
    salvaCriteri: "Salva i criteri",
    criteriSalvati: "Criteri salvati",
    cause: "Cause",
    altreListe: "Altre liste",
    nuovaVoce: "Nuova voce",
    aggiunta: "Voce aggiunta",
    disattiva: "Disattiva",
    riattiva: "Riattiva",
    disattivata: "disattivata",
    cambio: "Cambio USD → EUR",
    cambioNota: "Come nel file settimanale. Si aggiorna a mano.",
    cambioSalvato: "Cambio salvato",
  },
  registro: {
    titolo: "Registro operazioni",
    sottotitolo: "Chi ha fatto cosa e quando. Mai i valori, solo i campi cambiati.",
    quando: "Quando",
    chi: "Chi",
    cosa: "Cosa",
    dove: "Dove",
    dettaglio: "Dettaglio",
    tutte: "Tutte le entità",
    vuoto: "Nessuna operazione",
  },
  sf: {
    titolo: "Casi Salesforce (prova)",
    sottotitolo: "Reclami e segnalazioni di non conformità 2026 copiati da Salesforce Service (Fabric), in sola lettura. Serve a vedere entità e legami prima di decidere il modello del claim cliente.",
    prova: "Copia di prova: nessun collegamento viene salvato, si cancella con un comando",
    nonCaricati: "Nessun caso caricato in questo ambiente",
    nonCaricatiNota: "Lo schema sf_staging si carica con scripts/sf-staging.sh carica.",
    caricatiIl: "Caricati il {{data}}: {{casi}} casi, {{posizioni}} posizioni, {{storia}} cambi di stato",
    cliente: "Cliente o brand",
    stato: "Stato",
    recordType: "Record type",
    cerca: "Numero del caso o oggetto",
    numero: "Caso",
    account: "Cliente",
    brand: "Brand",
    oggetto: "Oggetto",
    apertoIl: "Aperto il",
    chiusoIl: "Chiuso il",
    responsabilita: "Responsabilità NC",
    risoluzione: "Risoluzione",
    importoClaim: "Importo claim",
    posizioni: "Posizioni",
    vuoto: "Nessun caso con questi filtri",
    apriSalesforce: "Apri in Salesforce",
    dati: "Dati del caso",
    origine: "Origine",
    priorita: "Priorità",
    codiceSap: "Codice SAP cliente",
    businessUnit: "Business unit",
    descrizione: "Descrizione",
    causa: "Causa",
    tipoClaim: "Tipo di claim",
    storiaClaim: "Storia del claim",
    azione: "Azione",
    commentoRisoluzione: "Commento alla risoluzione",
    ufficio: "Ufficio di risoluzione",
    reparto: "Reparto",
    prodottoNonConforme: "Prodotto non conforme",
    approvazioneNc: "Approvazione NC",
    statoApprovazione: "Approvazione",
    statoApprovazioneClaim: "Approvazione del claim",
    notaCredito: "Nota di credito richiesta",
    reso: "Reso richiesto",
    ritardo: "Ritardo di produzione",
    valoreMerce: "Valore merce contestata",
    deltaNote: "Delta note di credito",
    si: "sì",
    no: "no",
    ordine: "Ordine",
    consegna: "Consegna",
    prodotto: "Prodotto",
    materiale: "Materiale",
    produzione: "Produzione",
    qta: "Q.tà consegnata / ispezionata / difettosa",
    mancanti: "Mancanti / sostituite",
    prezzo: "Prezzo unitario",
    prezzoErrato: "prezzo errato",
    nessunaPosizione: "Nessuna posizione contestata",
    storia: "Storia",
    soloStati: "Solo cambi di stato e owner",
    campo: "Campo",
    da: "Da",
    a: "A",
    nessunaStoria: "Nessun cambio registrato",
    redFlag: "Possibili Red Flag collegate",
    redFlagNota: "Proposta, non collegamento: per numero del caso citato nella fonte della segnalazione o per nome del cliente o del brand.",
    perNumero: "numero del caso",
    perNome: "stesso nome",
    nessunaRedFlag: "Nessuna Red Flag con questo cliente o questo numero",
  },
};

export const en: Forma<typeof it> = {
  accessi: {
    titolo: "Access and roles",
    sottotitolo: "Standard portal setup: Entra app, roles per section, sso-qa group.",
    invita: "Add a person",
    invitaNota: "Prepare the user with their roles, one per section: they sign in with their Brandart account. No automatic email.",
    email: "Email",
    nome: "Name",
    ruolo: "Role",
    aggiunto: "User prepared",
    ruoli: "Roles",
    sezione: "Section",
    anche: "also",
    almenoUnRuolo: "At least one role",
    chi: "Who",
    cosaFa: "What they can do",
    nessunoTest: "nobody in test",
    soloMario: "Only Mario signs in to test. Other people are added after the review, with no automatic emails.",
    ssoSpento: "SSO is off in this environment: development login applies.",
    utenti: "Users",
    stato: "Status",
    attivo: "active",
    disattivato: "disabled",
    disattiva: "Disable",
    riattiva: "Enable",
    ultimoAccesso: "Last sign in",
    richieste: "Access requests",
    nessunaRichiesta: "No requests",
    nessunaRichiestaNota: "Whoever signs in without a role sees “Request access”; the request lands here.",
    motivo: "Reason",
    quando: "When",
    gestita: "Handled",
    rifiuta: "Reject",
    statoRichiesta: { aperta: "open", gestita: "handled", rifiutata: "rejected" },
    salvato: "Saved",
  },
  liste: {
    titolo: "Lists and criteria",
    sottotitolo: "The rules that today live in people's heads, written down once.",
    severita: "Severity",
    salvaCriteri: "Save criteria",
    criteriSalvati: "Criteria saved",
    cause: "Causes",
    altreListe: "Other lists",
    nuovaVoce: "New item",
    aggiunta: "Item added",
    disattiva: "Disable",
    riattiva: "Enable",
    disattivata: "disabled",
    cambio: "USD → EUR rate",
    cambioNota: "As in the weekly file. Updated by hand.",
    cambioSalvato: "Rate saved",
  },
  registro: {
    titolo: "Activity log",
    sottotitolo: "Who did what and when. Never the values, only the changed fields.",
    quando: "When",
    chi: "Who",
    cosa: "What",
    dove: "Where",
    dettaglio: "Detail",
    tutte: "All entities",
    vuoto: "No activity",
  },
  sf: {
    titolo: "Salesforce cases (trial)",
    sottotitolo: "2026 complaints and NC reports copied from Salesforce Service (Fabric), read-only. Used to see entities and links before deciding the customer claim model.",
    prova: "Trial copy: no link is saved, it is removed with one command",
    nonCaricati: "No cases loaded in this environment",
    nonCaricatiNota: "The sf_staging schema is loaded with scripts/sf-staging.sh carica.",
    caricatiIl: "Loaded on {{data}}: {{casi}} cases, {{posizioni}} positions, {{storia}} status changes",
    cliente: "Customer or brand",
    stato: "Status",
    recordType: "Record type",
    cerca: "Case number or subject",
    numero: "Case",
    account: "Customer",
    brand: "Brand",
    oggetto: "Subject",
    apertoIl: "Opened on",
    chiusoIl: "Closed on",
    responsabilita: "NC liability",
    risoluzione: "Resolution",
    importoClaim: "Claim amount",
    posizioni: "Positions",
    vuoto: "No cases with these filters",
    apriSalesforce: "Open in Salesforce",
    dati: "Case data",
    origine: "Origin",
    priorita: "Priority",
    codiceSap: "Customer SAP code",
    businessUnit: "Business unit",
    descrizione: "Description",
    causa: "Cause",
    tipoClaim: "Claim type",
    storiaClaim: "Claim history",
    azione: "Action",
    commentoRisoluzione: "Resolution comment",
    ufficio: "Resolution office",
    reparto: "Department",
    prodottoNonConforme: "Product out of spec",
    approvazioneNc: "NC approval",
    statoApprovazione: "Approval",
    statoApprovazioneClaim: "Claim approval",
    notaCredito: "Credit note requested",
    reso: "Return requested",
    ritardo: "Production delay",
    valoreMerce: "Value of disputed goods",
    deltaNote: "Credit note delta",
    si: "yes",
    no: "no",
    ordine: "Order",
    consegna: "Delivery",
    prodotto: "Product",
    materiale: "Material",
    produzione: "Production",
    qta: "Qty delivered / inspected / defective",
    mancanti: "Missing / replaced",
    prezzo: "Unit price",
    prezzoErrato: "wrong price",
    nessunaPosizione: "No disputed positions",
    storia: "History",
    soloStati: "Only status and owner changes",
    campo: "Field",
    da: "From",
    a: "To",
    nessunaStoria: "No changes recorded",
    redFlag: "Possibly related Red Flags",
    redFlagNota: "A suggestion, not a link: by case number quoted in the report source, or by customer or brand name.",
    perNumero: "case number",
    perNome: "same name",
    nessunaRedFlag: "No Red Flag with this customer or this number",
  },
};
